import { ref } from 'vue';

export const useApi = (request: (...arg0: any[]) => Promise<any>) => {
  const loading = ref(false);
  const result = ref();
  const error = ref();

  const fetchApi = async (...params: any[]) => {
    try {
      error.value = false;
      loading.value = true;
      result.value = await request(...params);
    } catch (e) {
      console.log('**error(fetchApi):', e);
      error.value = e;
    } finally {
      loading.value = false;
    }
  };

  return {
    fetchApi,
    loading,
    result,
    error,
  };
};